import { useMemo } from 'react';

import { usePermissions } from 'react-admin';

import { isExerciseEditor } from '../admin/permissions';

const useIsExerciseEditor = () => {
  const { permissions } = usePermissions();
  // NOTE: permissions is itself memoized
  const userIsExerciseEditor = useMemo(
    () => isExerciseEditor(permissions),
    [permissions],
  );

  return userIsExerciseEditor;
};
export default useIsExerciseEditor;
